<template>
  <div>
    <b-form novalidate @submit.stop.prevent="changePassword">

      <b-form-group
        id="current-password-input-group"
        :label="$t('changePassword.currentPasswordLabel')"
        label-for="current-password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="current-password-input"
          name="current-password"
          v-model="currentPassword"
          v-validate="{required: true, min: 6}"
          :state="validateState('current-password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('changePassword.currentPasswordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="new-password-input-group"
        :label="$t('changePassword.newPasswordLabel')"
        label-for="new-password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="new-password-input"
          ref="new-password"
          name="new-password"
          v-model="newPassword"
          v-validate="{required: true, min: '6'}"
          :state="validateState('new-password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('changePassword.newPasswordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="confirm-new-password-input-group"
        :label="$t('changePassword.confirmNewPasswordLabel')"
        label-for="confirm-new-password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="confirm-new-password-input"
          name="confirm-new-password"
          v-model="confirmNewPassword"
          v-validate="{required: true, confirmed: 'new-password'}"
          :state="validateState('confirm-new-password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('changePassword.confirmNewPasswordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col>
          <loading-button
            :text="$t('changePassword.btnText')"
            :loading-text="$t('changePassword.btnLoadingText')"
            variant="primary"
            :loading=submitting
            type="submit"
            :disabled="veeErrors.any()"
          />
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>

<script>
  import FormValidation from '../../mixins/FormValidation';
  import FormReset from '../../mixins/FormReset';

  export default {
    mixins: [FormValidation, FormReset],
    data() {
      return {
        submitting: false,
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      };
    },
    methods: {
      changePassword() {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.submitting = true;
          this.$store.dispatch('account/changePassword', {
            currentPassword: this.currentPassword,
            newPassword: this.newPassword,
          }).then(() => {
            this.$toasted.success(this.$t('changePassword.passwordChanged'));
            // Clear form
            this.clearForm();
          }).catch((err) => {
            let errorMessage = this.$t('changePassword.errorChangingPassword');
            if (err.response.status >= 400 && err.response.status < 500) {
              errorMessage = err.response.data.message;
            }
            this.$toasted.error(errorMessage);
          }).finally(() => {
            this.submitting = false;
          });
        });
      },
      clearForm() {
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.resetForm();
      },
    },
  };
</script>
